<template>
  <div class="flex flex-col w-full mx-auto p-8 ">
  

    <div class="flex justify-between my-4 h-96">
      <!-- Sidebar -->
       <!-- Select Location-->
      <div class="mb-4 bt-2">
     </div>
      <div class="mb-4 bg-orange">

        



<!--        <h2 class="text-xl mb-2 pt-4">Device</h2>-->
<!--        <div class="mb-4 bg-orange">-->
<!--          <label class="block text-sm font-bold mb-2">Select Device Type</label>-->
<!--          <select v-model="selectedDeviceType" @change="fetchDevices" class="w-full p-2 border rounded text-black">-->
<!--            <option value="nothing-selected" disabled>Nothing selected</option>-->
<!--            <option v-for="type in deviceTypes" :key="type.id" :value="type.id">{{ type.name }}</option>-->
<!--          </select>-->
<!--        </div>-->

        <div v-if="devices.length > 0" class="mb-4">
          <label for="deviceBox" class="block text-sm font-bold mb-2">Select Device</label>
          <div class="space-y-2">
            <div v-for="device in devices" :key="device.id" class="flex items-center">
              <input :id="'deviceBox-' + device.id" name="deviceBox" type="radio" :value="device.id" v-model="selectedDevice" @change="handleDeviceChange" class="mr-2">
              <label :for="'deviceBox-' + device.id" class="whitespace-nowrap">{{ device.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <!-- Main Content -->
      <div v-show="!showBiView" class="w-4/5 md:w-5/5">
        <div class="flex justify-between items-center mb-4">
        <button v-if="selectedDevice" class="bg-blue-500 text-white font-bold rounded-md px-3 py-1" @click="changeView">
                  {{ showBiView ? 'BI View' : 'Map View' }}
        </button>

          <select id="chartView" v-model="selectedChartType" @change="handleDeviceChange" class="p-1 border rounded text-black text-sm ml-4">
            <option value="all-logs">All Logs</option>
            <option value="daily-average">Daily average</option>
            <option value="weekly-average">Weekly Average</option>
            <option value="monthly-average">Monthly Average</option>
          </select>
        </div>

        <div class="mb-4">
          <line-chart :chart-data="chartData" />
        </div>
        <div class="mb-4">
          <button @click="exportData" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Export Data</button>
        </div>
        <div class="overflow-x-auto" v-if="deviceData.length">
          <table class="min-w-full bg-white border border-gray-300">
            <thead>
              <tr>
                <th v-for="(value, key) in deviceData[0]" :key="key" class="px-4 py-2 border border-gray-300 bg-gray-100">{{ key }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in deviceData" :key="index" class="hover:bg-gray-100">
                <td v-for="(value, key) in data" :key="key" class="border px-4 py-2">{{ value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination-element
          v-if="totalItems > 0"
          :total-items="totalItems"
          :page-size="perPage"
          v-model:current-page="currentPage"
          @page-change="fetchPaginatedDeviceData"
        />
      </div>
      <!-- BI View -->
      <div v-show="showBiView" class="w-full relative">

        <button v-if="selectedDevice" class="absolute left-0 top-0 z-20 bg-blue-500 text-white font-bold rounded-md px-3 py-1 mb-2" @click="changeView">
            {{ showBiView ? 'BI View' : 'Map View' }}
        </button>

        <MapBox :location-data="locationStore.selectedLocation" />

      </div>
    </div>

    <div class="flex flex-row justify-between">
      <div class="flex flex-col">
        <h1 class="text-4xl font-thin text-start my-6">Analytics</h1>
        <div class="flex flex-row space-x-2">
          <h1 @click="selectTimeframe('last7days')" :class="['font-bold cursor-pointer rounded-lg hover:bg-slate-100 p-2', selectedTimeframe === 'last7days' ? 'text-slate-800' : 'text-slate-400', 'text-lg lg:text-2xl']">
  Last 7 Days
</h1>
          <h1 @click="selectTimeframe('last30days')" :class="['font-bold text-2xl cursor-pointer rounded-lg hover:bg-slate-100 p-2', selectedTimeframe === 'last30days' ? 'text-slate-800' : 'text-slate-400', 'text-lg lg:text-2xl']">Last 30 Days</h1>
          <h1 @click="selectTimeframe('custom')" :class="['font-bold text-2xl cursor-pointer rounded-lg hover:bg-slate-100 p-2', selectedTimeframe === 'custom' ? 'text-slate-800' : 'text-slate-400', 'text-lg lg:text-2xl']">Custom</h1>
        </div>
        <!-- Custom date picker shown only when 'Custom' is selected -->
        <div v-if="selectedTimeframe === 'custom'" class="flex flex-row space-x-4 mt-4">
          <input type="date" v-model="customStartDate" class="border p-2 rounded" />
          <input type="date" v-model="customEndDate" class="border p-2 rounded" />
          <button @click="applyCustomRange" class="bg-blue-500 text-white px-4 py-2 rounded">Apply</button>
        </div>
      </div>
      <div class="flex flex-row space-x-4 items-center">
  <div class="w-40 h-20 bg-red-600 rounded-2xl cursor-pointer lg:w-32 md:h-16" @click="filterData('3_failures')">
    <h1 class="text-xl font-bold text-white md:text-lg">Critical</h1>
    <h1 class="text-4xl font-bold text-white md:text-3xl">{{ threeFailures }}</h1>
  </div>
  <div class="w-40 h-20 bg-orange-500 rounded-2xl cursor-pointer lg:w-32 md:h-16" @click="filterData('2_failures')">
    <h1 class="text-xl font-bold text-white md:text-lg">High</h1>
    <h1 class="text-4xl font-bold text-white md:text-3xl">{{ twoFailures }}</h1>
  </div>
  <div class="w-40 h-20 bg-purple-500 rounded-2xl cursor-pointer lg:w-32 md:h-16" @click="filterData('1_failure')">
    <h1 class="text-xl font-bold text-white md:text-lg">Moderate</h1>
    <h1 class="text-4xl font-bold text-white md:text-3xl">{{ oneFailure }}</h1>
  </div>
</div>


    </div>
    <DrillDownTable
      :fetch-string="fetchString"
      :details-fetch-string="detailsFetchString"
    />
    
 


  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import axios from 'axios';
import LineChart from '../components/LineChart.vue';
import PaginationElement from '../components/PaginationElement.vue';
import MapBox from "@/components/MapBox.vue";
import DrillDownTable from "@/components/DrillDownTable.vue";
import { useLocationStore } from '@/stores/locationStore'; // ✅ Import global store

const locationStore = useLocationStore(); // ✅ Access global store

const deviceData = ref([]);
const chartData = ref({});
const currentPage = ref(1);
const totalItems = ref(0);
const perPage = ref(10);
const selectedDevice = ref(null);
const selectedChartType = ref('daily-average');
const devices = ref([]);
const selectedTimeframe = ref(null);
const customStartDate = ref('');
const customEndDate = ref('');
const logSummary = ref({});
const threeFailures = ref(0);
const twoFailures = ref(0);
const oneFailure = ref(0);
const threeFailuresRoutes = ref([]);
const twoFailuresRoutes = ref([]);
const oneFailureRoutes = ref([]);
const fetchString = ref('');
const detailsFetchString = ref('logs/get_route_error_log_details/{id}/?');
const startDate = ref('');
const endDate = ref('');
const showBiView = ref(true);

const API_URL = process.env.VUE_APP_API_URL;

const labelColumns = {
  temperature: { label: 'Temperature', color: 'rgba(255, 99, 132, 1)', backgroundColor: 'rgba(255, 99, 132, 0.2)' },
  humidity: { label: 'Humidity', color: 'rgba(54, 162, 235, 1)', backgroundColor: 'rgba(54, 162, 235, 0.2)' },
};

const chartViewTypes = {
  'all-logs': { label: 'Time', field: 'time' },
  'daily-average': { label: 'Date', field: 'date' },
  'weekly-average': { label: 'Week', field: 'week' },
  'monthly-average': { label: 'Month', field: 'month' },
};

const changeView = () => {
  showBiView.value = !showBiView.value;
};

const fetchChartData = async () => {
  if (!selectedDevice.value || !locationStore.selectedLocation?.id) return;

  const apiUrl = `${API_URL}iotdata/dragino_data_all/?device=${selectedDevice.value}&type_of_chart=${selectedChartType.value}&location=${locationStore.selectedLocation.id}`;
  const response = await axios.get(apiUrl);

  const all_data = response.data;
  const viewType = chartViewTypes[selectedChartType.value];
  const labels = all_data.map(item => item[viewType.field]);

  const datasets = Object.keys(labelColumns).map(key => ({
    label: labelColumns[key].label,
    data: all_data.map(item => item[key]),
    borderColor: labelColumns[key].color,
    backgroundColor: labelColumns[key].backgroundColor
  }));

  chartData.value = { labels, datasets };
};

const fetchPaginatedDeviceData = async (page = currentPage.value) => {
  if (!selectedDevice.value || !locationStore.selectedLocation?.id) return;

  const apiUrl = `${API_URL}iotdata/dragino_data_paginated/?page=${page}&device=${selectedDevice.value}&type_of_chart=${selectedChartType.value}&location=${locationStore.selectedLocation.id}`;
  const response = await axios.get(apiUrl);

  deviceData.value = response.data.results || [];
  totalItems.value = response.data.count;
  currentPage.value = page;
};

const fetchLogSummary = async (startDate, endDate) => {
  if (!locationStore.selectedLocation?.id) return;

  const response = await axios.get(`${API_URL}logs/get_route_error_summary/?start_date=${startDate}&end_date=${endDate}&location=${locationStore.selectedLocation.id}`);
  const data = response.data;
  logSummary.value = data;
  threeFailures.value = data.grouped_results['3_or_more_scenarios'].count;
  twoFailures.value = data.grouped_results['2_scenarios'].count;
  oneFailure.value = data.grouped_results['1_scenario'].count;

  threeFailuresRoutes.value = data.grouped_results['3_or_more_scenarios'].details;
  twoFailuresRoutes.value = data.grouped_results['2_scenarios'].details;
  oneFailureRoutes.value = data.grouped_results['1_scenario'].details;
};

const handleDeviceChange = () => {
  currentPage.value = 1;
  fetchChartData();
  fetchPaginatedDeviceData();
};

const exportData = () => {
  if (deviceData.value.length === 0) return;

  const keys = Object.keys(deviceData.value[0]);
  const csvContent = 'data:text/csv;charset=utf-8,' +
    keys.join(',') + '\n' +
    deviceData.value.map(e => keys.map(k => e[k]).join(',')).join('\n');

  const link = document.createElement('a');
  link.setAttribute('href', encodeURI(csvContent));
  link.setAttribute('download', 'device_data.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const selectTimeframe = (timeframe) => {
  selectedTimeframe.value = timeframe;

  if (timeframe === 'last7days') {
    const last7 = new Date();
    last7.setDate(last7.getDate() - 7);
    startDate.value = last7.toISOString().split('T')[0];
    endDate.value = new Date().toISOString().split('T')[0];
  } else if (timeframe === 'last30days') {
    const last30 = new Date();
    last30.setDate(last30.getDate() - 30);
    startDate.value = last30.toISOString().split('T')[0];
    endDate.value = new Date().toISOString().split('T')[0];
  }

  fetchString.value = `logs/get_route_error_logs/?start_date=${startDate.value}&end_date=${endDate.value}&location=${locationStore.selectedLocation?.id || ''}`;
  fetchLogSummary(startDate.value, endDate.value);
};

const applyCustomRange = () => {
  if (!customStartDate.value || !customEndDate.value) return;

  startDate.value = customStartDate.value;
  endDate.value = customEndDate.value;
  selectTimeframe('custom');
};

const filterData = (filter) => {
  let data = [];

  if (filter === '3_failures') {
    data = threeFailuresRoutes.value.map(route => route.route);
  } else if (filter === '2_failures') {
    data = twoFailuresRoutes.value.map(route => route.route);
  } else if (filter === '1_failure') {
    data = oneFailureRoutes.value.map(route => route.route);
  }

  const filterQuery = data.join(',');
  fetchString.value = `logs/get_route_error_logs/?start_date=${startDate.value}&end_date=${endDate.value}&location=${locationStore.selectedLocation.id || ''}&filter=${filterQuery}`;
};

onMounted(() => {
  locationStore.fetchLocations(); // just in case
  selectTimeframe('last30days');
});

watch(() => locationStore.selectedLocation, () => {
  if (!locationStore.selectedLocation?.id) return;

  selectTimeframe(selectedTimeframe.value || 'last30days');
  fetchLogSummary(startDate.value, endDate.value);
  fetchChartData();
  fetchPaginatedDeviceData();

  // Update fetchString to re-trigger DrillDownTable
  fetchString.value = `logs/get_route_error_logs/?start_date=${startDate.value}&end_date=${endDate.value}&location=${locationStore.selectedLocation.id}`;
});


watch(currentPage, fetchPaginatedDeviceData);
</script>


<style scoped>
</style>
